import { useEffect, useContext } from "react";
import { Route, Routes } from "react-router-dom";
import SignupProvider, { SignupContext } from "../../../context/SignupContext";
import Step1 from "./register/Step1";
import Step2 from "./register/Step2";
import Step3 from "./register/Step3";
import Step4 from "./register/Step4";
import StepPhone from "./phone/Step1";
import StepVerifyPhone from "./phone/Step2";
import Step5 from "./register/Step5";
import APILoader from "../../../components/APILoader";

const Register = () => {
  // const [nextPath, setNextPath] = useState({ action: () => verifyCaptchaCode(), actionName: "Verify", path: "verify", progress: "25%" });
  // const location = useLocation();
  const context = useContext(SignupContext);

  const { formData, loading } = context;

  // const navigate = useNavigate();

  // useEffect(() => {
  //   // console.log("SIgnUP Index  ; ", location.pathname);
  //   // console.log("SIgnUP Index ; ", formData);
  //   switch (location.pathname) {
  //     case "/onboard/creator/verify":
  //       setNextPath({ action: () => verifyCode(), actionName: "Verify", path: "password", progress: "50%" });
  //       break;
  //     case "/onboard/creator/password":
  //       setNextPath({ action: () => signUp(), actionName: "Continue", path: "finish", progress: "75%" });
  //       break;
  //     case "/onboard/creator/finish":
  //       setNextPath({ action: () => createProfile(), actionName: "Finish", path: "verify", progress: "100%" });
  //       break;
  //     default:
  //       setNextPath({ action: () => verifyCaptchaCode(), actionName: "Continue", path: "verify", progress: "25%" });
  //       break;
  //   }
  // }, [location, formData]);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  // const verifyCaptchaCode = () => {
  //   verifyCaptcha().then(val => {
  //     if (val) {
  //       navigate("/onboard/creator/verify");
  //     }
  //   });
  // };
  // const verifyCode = async () => {
  //   var val = await verifyOtp();
  //   if (val) {
  //     navigate("/onboard/creator/password");
  //   }
  // };
  // const signUp = async () => {
  //   navigate("/onboard/creator/finish");
  // };

  // const createProfile = async () => {
  //   // const data = {
  //   //   email: email ?? "",
  //   //   password: password ?? "",
  //   //   firstName: firstName ?? "",
  //   //   lastName: lastName ?? "",
  //   //   dob: dob ?? "",
  //   // };

  //   var val = await callApi();
  //   if (val) {
  //     navigate("../setupFee");
  //   }
  // };

  return (
    <>
      {/* {loading && <Loader />} */}
      <APILoader loading={loading} />
      <SignupProvider>
        <Routes>
          <Route path="/" element={<Step1 />} />
          <Route path="verify" element={<Step2 />} />
          <Route path="verifyEmail" element={<Step3 />} />
          <Route path="password" element={<Step4 />} />
          <Route path="twofactor" element={<StepPhone />} />
          <Route path="verifyOtp" element={<StepVerifyPhone />} />
          <Route path="success" element={<Step5 />} />
        </Routes>
      </SignupProvider>
    </>
  );
};

export default Register;
